export const SET_PROFILE_TYPES = 'profile-types/set-profile-types';
export const REMOVE_PROFILE_TYPE = 'profile-types/remove-profile-type';
export const REMOVE_ATTRIBUTE = 'profile-types/remove-attribute';
export const SET_ATTRIBUTES = 'profile-types/set-attributes';
export const SET_SELECTED_PROFILE_TYPE = 'profile-types/set-selected-profile-type';
export const SET_SELECTED_ATTRIBUTE_FOR_PROFILETYPE = 'profile-types/set-selected-attribute-for-profile-type';
export const SET_SELECTED_ATTRIBUTE = 'profile-types/set-selected-attribute';
export const PUSH_PARENT_SELECTED_ATTRIBUTE = 'profile-types/push-parent-selected-attribute';
export const POP_PARENT_SELECTED_ATTRIBUTE = 'profile-types/pop-parent-selected-attribute';
export const SET_SELECTED = 'profile-types/set-selected';
export const MOVE_ATTRIBUTE_UP = 'profile-types/move-attribute-up';
export const MOVE_ATTRIBUTE_DOWN = 'profile-types/move-attribute-down';
export const SET_PROFILE_TYPE_REFERENCE_STATUS = 'profile-types/set-reference-status';
export const SET_ACTION_MODE = 'profile-types/set-action-mode';
export const REMOVE_ATTRIBUTE_FROM_COMPOSITE = 'profile-types/remove-attribute-from-composite';
export const MOVE_ATTRIBUTE_FROM_COMPOSITE = 'profile-types/move-attribute-from-composite';
export const SET_NEW_ATTRIBUTE_COMPOSITE = 'profile-types/set-new-attribute-composite';
export const SET_SELECTED_NESTED_ATTRIBUTE = 'profile-types/set-selected-nested-attribute';
